import { render, staticRenderFns } from "./DoctorCommisionForm.vue?vue&type=template&id=2bdcac8d&scoped=true&"
import script from "./DoctorCommisionForm.vue?vue&type=script&lang=js&"
export * from "./DoctorCommisionForm.vue?vue&type=script&lang=js&"
import style0 from "./DoctorCommisionForm.vue?vue&type=style&index=0&id=2bdcac8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdcac8d",
  null
  
)

export default component.exports